import {Button} from 'react-bootstrap'
import React, {useState} from 'react'
import styled from 'styled-components'
import {confirmAlert} from 'react-confirm-alert'
import {organizationApiClient} from 'organization/organizationApiClient'
import {toast} from 'react-toastify'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import {useI18n} from 'i18n/I18nContext'

export const CertificationConfig = () => {
  const {t} = useI18n()
  const apiClient = organizationApiClient()
  const {event} = useOrganizationEvent()
  const [, setLoading] = useState<boolean>(true)

  const issueCertificates = () => {
    confirmAlert({
      message: t('orgCert.confirmIssue'),
      buttons: [
        {
          label: t('common.yes'),
          onClick: () => {
            setLoading(true)

            apiClient
              .post(`api/event/${event?.id}/certificate/issue`)
              .then(() => {
                toast.success(t('orgCert.issueSuccess'))
              })
              .catch(() => {
                toast.warning(t('orgCert.issueError'))
              })
              .finally(() => {
                setLoading(false)
              })
          },
        },
        {
          label: t('common.no'),
          onClick: () => {
            // nothing
          },
        },
      ],
    })
  }

  return (
    <div className="create__event-area mb-20 col-12">
      <div className="body__card-wrapper attendant__wrapper">
        <EventStatusHolder className="row">
          <div className="col-12 col-lg-8 mb-15">
            <p>
              <b>{t('orgCert.issueTitle')} </b>
            </p>
            <div>{t('orgCert.issueIntro')}</div>
          </div>
          <div
            className="col-12 col-lg-4"
            style={{display: 'flex', justifyContent: 'right'}}
          >
            <Button className="input__btn w-auto" onClick={issueCertificates}>
              {t('orgCert.issueButton')}
            </Button>
          </div>
        </EventStatusHolder>
      </div>
    </div>
  )
}
const EventStatusHolder = styled.div`
  align-items: center;
`
